import { Component, Input, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { AsyncPipe, DatePipe, NgFor, NgIf, SlicePipe } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { IDraftEmail, SentEmail } from '../../../models/email-message';
import { Store } from '@ngxs/store';
import { ChipsModule } from 'primeng/chips';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { EditorModule } from 'primeng/editor';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { IEmailHandler } from '../email-handler';
import { UserState } from '../../../state/user/user-state';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { EmailComposerComponent } from '../email-composer/email-composer.component';


@Component({
  selector: 'app-sent-email-list',
  standalone: true,
  imports: [CardModule, SlicePipe, NgIf, NgFor,PanelModule, TagModule,DividerModule, DatePipe, ButtonModule,
    OverlayPanelModule,TableModule,TooltipModule, ChipsModule, FloatLabelModule,FormsModule,InputTextModule, 
    EditorModule,ButtonGroupModule, AsyncPipe, DropdownModule, CheckboxModule, ChipModule, DividerModule,
    BadgeModule, DialogModule, EmailComposerComponent],
  templateUrl: './sent-email-list.component.html',
  styleUrl: './sent-email-list.component.scss'
})
export class SentEmailListComponent
{
  @Input() showSend: boolean = true;
  @Input() emailHandler: IEmailHandler | undefined = undefined;
  @Input() emails?: SentEmail[] = [];

  @ViewChild('newEmailOp') emailEditor?: OverlayPanel;


  constructor(protected _store:Store)
  {
  }

  draftEmail? : IDraftEmail;
  newEmailDialogVisible: boolean = false;
  
  viewEmailVisible: boolean = false;
  selectedViewEmail: SentEmail | null = null;

  openViewEmail(email: SentEmail): void {
    this.selectedViewEmail = email;
    this.viewEmailVisible = true;
  }
  
  get sortedEmails() : SentEmail[]
  {
    if (!this.emails) {
      return [];
    }

    return [...this.emails].sort((a, b) => new Date(b.dateSent).valueOf() - new Date(a.dateSent).valueOf());
  }

  currentUser$ = this._store.select(UserState.currentUser);

  expandedEmails: boolean[] = [];

    newDraftEmail()
  {
    this.draftEmail = {} as IDraftEmail
    this.draftEmail.recipients = [];
    this.draftEmail.ccs = [];
    this.draftEmail.bccs = [];
  }


  sendEmail(draftEmail: IDraftEmail)
  {
    this.emailHandler?.sendEmail(draftEmail).then(email => this.newEmailDialogVisible = false);
  }

  cancelEmail()
  {
    this.draftEmail = undefined;
  }

  draftSaved()
  {
    this.draftEmail = undefined;
  }
}


